var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXcross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0659 7.93414C16.3587 8.22703 16.3587 8.70191 16.0659 8.9948L8.99478 16.0659C8.70189 16.3588 8.22702 16.3588 7.93412 16.0659C7.64123 15.773 7.64123 15.2981 7.93412 15.0052L15.0052 7.93414C15.2981 7.64125 15.773 7.64125 16.0659 7.93414Z",
    fill: "#09091C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0659 16.0659C15.773 16.3587 15.2981 16.3587 15.0052 16.0659L7.93413 8.99478C7.64124 8.70189 7.64124 8.22702 7.93413 7.93412C8.22703 7.64123 8.7019 7.64123 8.99479 7.93412L16.0659 15.0052C16.3588 15.2981 16.3588 15.773 16.0659 16.0659Z",
    fill: "#09091C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXcross);
export default __webpack_public_path__ + "static/media/xcross.a6f70340754548d95f2f6c16eed01941.svg";
export { ForwardRef as ReactComponent };